import { LoadingOutlined } from "@ant-design/icons";
import { Button, Form, Input, Modal, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";
import CreateTopUnitApi from "../../../api/CreateTopUnitApi";
import { GetOrganizationLevelsApi } from "../../../api/org-levels/GetOrganizationLevelsApi";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../../helpers/NotificationHelpers";

const { Option } = Select;

function AddTopUnitModal(props) {
  const [organizationLevels, setOrganizationLevels] = useState([]);
  const [submit, setSubmit] = useState(false);

  function handleCancel() {
    setOrganizationLevels([]);
    setSubmit(false);
    props.handleCancel();
  }

  useEffect(() => {
    if (props.visible) {
      getOrganizationLevels();
    }
  }, [props.visible]);

  async function getOrganizationLevels() {
    const apiResponse = await GetOrganizationLevelsApi();
    console.log(apiResponse);
    if (apiResponse.message === "success") {
      setOrganizationLevels(apiResponse.levels);
    }
  }

  async function onFinish(value) {
    setSubmit(true);
    const apiResponse = await CreateTopUnitApi(value.unitName);

    if (apiResponse.statusCode) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.message === "success") {
      openNotificationSuccess("bottomRight", "Unit added successfully");
      props.handleOk();
    } else {
      openNotificationError(
        "bottomRight",
        "Couldn't add unit. Try again later."
      );
    }
    handleCancel();
  }

  function getTopLevelId() {
    let output = "";
    organizationLevels?.forEach((level) => {
      if (level.order === 1) {
        output = level.id;
      }
    });
    return output;
  }

  return (
    <Modal
      title="Add new unit"
      visible={props.visible}
      onCancel={() => handleCancel()}
      footer={null}
      destroyOnClose={true}
    >
      <Spin spinning={organizationLevels?.length === 0}>
        {!!organizationLevels?.length && (
          <Form
            name="addUnit"
            onFinish={onFinish}
            layout="vertical"
            requiredMark={false}
            autoComplete="off"
            initialValues={{ orgLevel: getTopLevelId() }}
          >
            <Form.Item
              label="Org level*"
              name="orgLevel"
              rules={[
                {
                  required: true,
                  message: "Please select a level!",
                },
              ]}
            >
              <Select disabled placeholder="Select org level">
                {organizationLevels.map((level) => {
                  if (level.order === 1) {
                    return (
                      <Option key={level.id} value={level.id}>
                        {level.name}
                      </Option>
                    );
                  }
                })}
              </Select>
            </Form.Item>

            <Form.Item
              label="Unit name*"
              name="unitName"
              rules={[
                {
                  required: true,
                  message: "Please enter name!",
                },
              ]}
            >
              <Input placeholder="Unit name" />
            </Form.Item>

            <Form.Item style={{ marginBottom: 0 }}>
              <div className=" flex justify-end">
                <Button className="mr-3 w-28" onClick={() => handleCancel()}>
                  Cancel
                </Button>
                <Button
                  className="btn w-28"
                  type="primary"
                  htmlType={submit && "submit"}
                  disabled={submit}
                >
                  {submit ? (
                    <Spin
                      size="small"
                      indicator={
                        <LoadingOutlined style={{ color: "#fff" }} spin />
                      }
                    />
                  ) : (
                    "Add"
                  )}
                </Button>
              </div>
            </Form.Item>
          </Form>
        )}
      </Spin>
    </Modal>
  );
}

export default AddTopUnitModal;
